module.exports = __webpack_public_path__ + "img/folder.76a279fd.webp";